import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import {
  WebUrl
} from "../../util/Constant";
import { stringIsNullOrEmpty } from "../../util/Util";
import moment from "moment/moment";
import * as QRCode from 'qrcode';
import { Accordion } from "react-bootstrap";

const CustomQRISDeposit = (props) => {
  var _history = useHistory();
  var { t } = useTranslation();

  const canvasRef = useRef(null);
  const qrcodeRef = useRef(null);
  const [isQrcodeGeneral, setIsQrcodeGeneral] = useState(false);
  const [isShowForm, setIsShowForm] = useState(false);

  useEffect(() => {
    if (!stringIsNullOrEmpty(props.paymentList.qrcode)) {
      QRCode.toCanvas(canvasRef.current, props.paymentList.qrcode, { width: 256 }, (error) => {
        setIsQrcodeGeneral(true);
      });
    }
  }, [props]);

  const [remainingTime, setRemainingTime] = useState(
    moment(props.paymentList.expiredTime).diff(moment())
  );

  useEffect(() => {
    const interval = setInterval(() => {
      const now = moment(moment());
      const diff = moment(props.paymentList.expiredTime).diff(now);

      if (diff <= 0) {
        clearInterval(interval);
        setRemainingTime(0);
      } else {
        setRemainingTime(diff);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [props.paymentList.expiredTime]);


  const formatDuration = (ms) => {
    const duration = moment.duration(ms);
    const hours = String(duration.hours()).padStart(2, '0');
    const minutes = String(duration.minutes()).padStart(2, '0');
    const seconds = String(duration.seconds()).padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  };

  const handleDownload = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const url = canvas.toDataURL('image/png');
    const a = document.createElement('a');
    a.href = url;
    a.download = 'qrcode.png';
    a.click();
  };

  return (
    <>
      {Object.keys(props.paymentList).length > 0 &&
        <div className="minera-pay-main-div">

          <div className="first">
            <div className="amount">{t("DEPOSIT_AMOUNT_MYR", { value: (props.paymentList.amount) })}</div>
            <div className="time-box">
              <div>{t("REMAINING_TIME_EXPIRED")}</div>
              <div>{remainingTime > 0 ? formatDuration(remainingTime) : 'Expired'}</div>
            </div>
          </div>
          <div className="second">
            <div className="qrcode shadow rounded" ref={qrcodeRef}>
              <img className="minirepayQRis" src="https://cdn.i8global.com/i8app/qris-202309051444148291.png" alt="qrisIcon" />
              <div className="qrcode-canvas">
                {isQrcodeGeneral &&
                  <canvas ref={canvasRef} className="bg-white" />
                }
              </div>
            </div>
            <div className="btn custom-btn-style-2" onClick={handleDownload}>{t("DOWNLOAD_QR_CODE")}</div>
          </div>
          <div className="third">
            <div className="item">
              <div>
                {t("PAYMENT_METHOD")}
              </div>
              <div>
                {props.paymentList.paymentMethod}
              </div>
            </div>
            <div className="item">
              <div>
                {t("REFERENCE_NO")}
              </div>
              <div>
                {props.paymentList.referenceNo}
              </div>
            </div>
            <div className="item">
              <div>
                {t("PRODUCT")}
              </div>
              <div>
                {t(props.paymentList.product)}
              </div>
            </div>
          </div>
          <div className="btn custom-btn-style-2" onClick={() => _history.push(WebUrl._URL_MAIN)}>{t("I_HAVE_PAID")}</div>
          <div className="fifth">
            <Accordion>
              <Accordion.Item eventKey="0">
                <Accordion.Header onClick={() => setIsShowForm(!isShowForm)}>
                  <div className="header">
                    <div className="first">
                      {t("QRIS_PAYMENT_GUIDE_TITLE")}
                    </div>
                    <div className="second">
                      <img
                        src={"/img/assets/next-page.svg"}
                        className="img-responsive"
                        alt="next-page"
                      />
                    </div>
                  </div>

                </Accordion.Header>
                <Accordion.Body>
                  <div className="body">
                    <div className="text-white mt-0">{t("QRIS_PAYMENT_GUIDE_1")}</div>
                    <div className="text-white mt-0">{t("QRIS_PAYMENT_GUIDE_2")}</div>
                    <div className="text-white mt-0">{t("QRIS_PAYMENT_GUIDE_3")}</div>
                    <div className="text-white mt-0">{t("QRIS_PAYMENT_GUIDE_4")}</div>
                    <div className="text-white mt-0">{t("QRIS_PAYMENT_GUIDE_5")}</div>
                    <div className="text-white mt-0">{t("QRIS_PAYMENT_GUIDE_6")}</div>
                    <div className="text-white mt-0">{t("QRIS_PAYMENT_GUIDE_7")}</div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>

          </div>
        </div>
      }
    </>
  );
};

export default CustomQRISDeposit;
